
  export default {
    meta: {
      breadcrumbs: [['i18n/home', '/', 'mobile'], 'i18n/privacy']
    },
    middleware: ['pages/privacy-policy', 'breadcrumbs', 'meta-tags'],
    computed: {
      langFile () {
        return this.$t('privacyPolicy');
      },
      sections () {
        return this.langFile.sections;
      },
      privacyPolicy () {
        return this.$store.getters['privacyPolicy/get'];
      }
    }
  };
